import { Organization } from '@teammood/shared/util/core';
import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";

@Injectable()
export class OrganizationService {

    constructor(private http: HttpClient) { }

    get(orgId: string) {
        return this.http.get<Organization>(`/api/organisation/${orgId}`);
    }

    update(orgId: string, organization: Partial<Organization>) {
        return this.http.put<{ message: string, newOrgId: string }>('/api/organisation/' + orgId, {organization });
    }

    create_team(orgId: string, teamName: string) {
        return this.http.post<{ teamId: string}>('/api/organisation/' + orgId + '/team/new', { orgId, teamName });
    }
}